'use strict';

module.exports.Spectrum = require('./Spectrum');
